import styled, { createGlobalStyle } from 'styled-components';
import { fadeIn } from '../Alert/styles';

export const BodyModalStyle = createGlobalStyle`
  body {
   padding-right: ${(props) => props.padRight || '0'}px;
   overflow-y: hidden;
  }
`;

export const ModalScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 100%;
  outline: 0;
  z-index: ${(props) => props.theme.zIndexes.modal};
  background-color: rgba(255, 255, 255, 0.8);
  animation: ${fadeIn} 0.15s ease-in;
`;

const widthMap = {
  xl: '90vw',
  large: '800px',
  default: '700px',
  small: '480px',
};

export const ModalDialog = styled.div`
  position: relative;
  width: auto;
  max-width: ${(p) => widthMap[p.size]};
  margin: 0 auto;
  top: 50%;
  transform: translateY(-50%);

  ${(p) => p.theme.mediaQueries.isMobile} {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
  }
`;

export const ModalContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: ${(props) => props.theme.colors.white};
  background-clip: padding-box;
  outline: 0;
  border-radius: 10px;
  box-shadow: ${(props) => props.theme.boxShadows.base};
  height: ${(props) => (props.theme.mediaQueries.isMobile ? '100%' : undefined)};
`;

export const ModalContentHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 25px;
  svg {
    cursor: pointer;
    pointer-events: auto;
  }

  ${(p) => p.theme.mediaQueries.isMobile} {
    padding: 16px;
  }
`;

export const ModalContentBody = styled.div`
  flex: 1 1 auto;
  padding: 0 25px 5px;
  max-height: ${(props) => (props.maxHeight ? props.maxHeight : 'unset')};
  overflow-y: ${(props) => (props.contentOverflow ? props.contentOverflow : 'auto')};

  ${(p) => p.theme.mediaQueries.isMobile} {
    padding: 16px;
  }
`;

export const ModalContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.center ? 'center' : 'flex-end')};
  padding: 25px;
  border-top: ${(props) =>
    props.borderTop ? `1px solid ${props.theme.colors.secondary90w}` : 'none'};

  ${(p) => p.theme.mediaQueries.isMobile} {
    padding: 16px;
  }
`;
